import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export const SvgChevronLeftSingle = () => {
    return (_jsx("svg", Object.assign({ viewBox: "0 0 30 30", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.4 4L8 14.4V15.45L18.4 25.8499L19.375 24.8999L11.05 14.925L19.375 4.95L18.4 4Z" }, void 0) }), void 0));
};
//# sourceMappingURL=chevron-left-single.js.map
